import { render } from "./OAuthClient.vue?vue&type=template&id=01769fa5"
import script from "./OAuthClient.vue?vue&type=script&lang=js"
export * from "./OAuthClient.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__